import React from 'react'
import styled from 'styled-components'

import { FormattedTimeByDate } from '../../components/FormattedTimeByDate'
import { FormattedDate } from '../../components/FormattedDate'

const Wrapper = styled.div`
  display: flex;
`

const CommaSeparator = styled.div`
  margin-right: 3px;
`

const Date = styled.div`
  white-space: nowrap;
`

const Time = styled.div`
  white-space: nowrap;
`

export const FormattedDateTime = ({ date, intl }) => {
  return (
    <Wrapper>
      <Date>
        <FormattedDate value={date} month="short" day="2-digit" />
      </Date>

      <CommaSeparator>,</CommaSeparator>

      <Time>
        <FormattedTimeByDate intl={intl} date={date} />
      </Time>
    </Wrapper>
  )
}
